var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"developing"},[_c('p',[_vm._v("((o(^_ ^)o)) "),_c('br'),_vm._v("该功能仍然迭代开发中，尽请期待..."),_c('br'),_c('br')])])}]

export { render, staticRenderFns }